
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as giwvd9pLpHOLX9dR11ExUuBlQFASsLuepOr5ySh2zZ0YMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUt6ZGkW_0fy7v8Ft_451R_V738Vo_45kliQR5X26ZBVohYQMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchbE7G390tstln3RUZQG5wubowJZpQ1aC_faEe6YyJmUAMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index73FgN_450Yjekuu_THXJ9PLnfBdiNVjotVbOqXGgeux3QMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93oDJt3wkaa22QWT869Fan3Q_KinsBEWp2KncI8mRNTEYMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexe3wGdpRzc2_45bkE0gdOYW1Qx6WeiQRaOI_45GQhBo9sskUMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ObYCqTUeCILgVCxyeOmj_osICF7isLOKkjZqiIGX5C8Meta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexKcqrEsxnAAaLJ6eT4_wVinOZ3Q2WFH21nJcY1eXFYfkMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93W8L3HvQ0beIRnX3iwmK_45cGThxnIDDdQnqKy_UbsjPT8Meta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexsx6eTB3XGk_3V9HWMWZwGdux154ZqTFgoEl5CJCfy80Meta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as article_45stream_45previewtvfitba8BMUadwpHtCSnYnfMI41ai31xoi4hen7ft9sMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/common/pages/article-stream-preview.vue?macro=true";
import { default as indexIXuDOwwCU9w6XGIolT112sYIKB9nqyEQzp3wedp1HCgMeta } from "/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexe3wGdpRzc2_45bkE0gdOYW1Qx6WeiQRaOI_45GQhBo9sskUMeta || {},
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexKcqrEsxnAAaLJ6eT4_wVinOZ3Q2WFH21nJcY1eXFYfkMeta || {},
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexsx6eTB3XGk_3V9HWMWZwGdux154ZqTFgoEl5CJCfy80Meta || {},
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "article-stream-preview",
    path: "/article-stream-preview",
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/common/pages/article-stream-preview.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexIXuDOwwCU9w6XGIolT112sYIKB9nqyEQzp3wedp1HCgMeta || {},
    component: () => import("/codebuild/output/src3515552685/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]